<div class="popup-container">
    <div class="popup-model" [ngClass]="{'minimal-mode': landingMinimal}">
        <div class="popup-header">
            <div class="popup-header-text">{{ headerTitle }}</div>
            <div class="popup-close" (click)="close()" title="Close"></div>
        </div>
        <div class="popup-body">
            <div class="popup-scrollable-content">
                        <!-- Title Field (editable unless read-only) -->
                        <div class="inputText">
                            <label for="title">Title</label>
                            <ng-container *ngIf="!readOnlyMode; else readonlyTitle">
                                <input type="text" id="title" placeholder="Enter your report name" [(ngModel)]="report.title" />
                            </ng-container>
                            <ng-template #readonlyTitle>
                                <input type="text" id="title" class="readonly-input" [value]="report.title || '—'" disabled />
                            </ng-template>
                        </div>

                <!-- Selection Summary (only show if value exists & not minimal) -->
                        <div class="inputText" *ngIf="!landingMinimal && showSelectionSummary">
                            <label for="summary">Selection Summary</label>
                            <ng-container *ngIf="!readOnlyMode; else readonlySelection">
                                <textarea rows="4" id="summary" [(ngModel)]="report.selectionSummary"></textarea>
                            </ng-container>
                            <ng-template #readonlySelection>
                                <textarea rows="4" id="summary" class="readonly-textarea" [value]="report.selectionSummary" disabled></textarea>
                            </ng-template>
                        </div>

                <!-- Experience / Description -->
                        <div class="inputText">
                            <label for="experience">Tell us about your experience</label>
                            <ng-container *ngIf="!readOnlyMode; else readonlyDescription">
                                <textarea rows="5" id="experience" [(ngModel)]="report.description"></textarea>
                            </ng-container>
                            <ng-template #readonlyDescription>
                                <textarea rows="5" id="experience" class="readonly-textarea" [value]="report.description || '—'" disabled></textarea>
                            </ng-template>
                        </div>

                <!-- Upload Area (hidden in read-only or minimal modes) -->
                <div class="inputText" *ngIf="!landingMinimal && !readOnlyMode">
                    <div class="file-upload-container">
                        <input type="file" id="fileInput" multiple (change)="onFileSelected($event)" hidden />
                        <label style="width:100%;height: 100%;" for="fileInput" class="file-upload-box">
                            <div class="file-container">
                                <span class="file-icon">
                                    <img src="assets/images/common/aesthetics/uploadfile-icon.svg" alt="Attachment" />
                                </span>
                                <p>Choose A File Or Drag And Drop</p>
                            </div>
                        </label>
                    </div>
                </div>

                <!-- File List (edit mode) -->
                <div class="inputText" *ngIf="!landingMinimal && !readOnlyMode">
                    <div class="file-list">
                        <div class="file-list-item" *ngFor="let file of files">
                            <div class="file-name">{{ file.name }}</div>
                            <div class="file-remove" (click)="removeFile(file)">X</div>
                        </div>
                    </div>
                </div>

                <!-- Attachments (read-only mode) -->
                        <!-- <div class="inputText" *ngIf="readOnlyMode">
                            <label>Attachments</label>
                            <div class="attachment-toolbar" [class.empty]="files.length === 0">
                                <div class="attachment-name" *ngFor="let file of files">{{ file.name }}</div>
                                <div class="no-attachments" *ngIf="files.length === 0">No attachments</div>
                            </div>
                        </div> -->

                <p *ngIf="uploadSizeExceed && !landingMinimal && !readOnlyMode" style="color:red">*Uploaded files exceeds limit 10MB</p>
            </div>

            <!-- Footer: Submit button only in create mode -->
            <div class="modal-footer" *ngIf="!readOnlyMode">
                <button class="submit-btn" (click)="submitReport()" [disabled]="!report.title || report.title.trim() === ''">
                    <img src="assets/images/common/aesthetics/submit-icon.svg" alt="Submit" class="btn-icon" />
                    Submit Report
                </button>
            </div>

            <!-- Footer (read-only): action buttons like screenshot design -->
                    <div class="modal-footer" *ngIf="readOnlyMode">
                        <!-- <button class="action-btn" (click)="onDownloadAllAttachments()" [disabled]="files.length === 0">&#128190; Download All Attachment</button> -->
                        <!-- <button class="action-btn" (click)="onDownloadReportExcel()">&#128196; Download Report As Excel</button> -->
                        <!-- <button class="action-btn secondary" (click)="close()">Close</button> -->
                    </div>
        </div>
    </div>
</div>

